import { History } from "history";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";

import { BackButton } from "triangular/components/BackButton/BackButton";
import { FormSection } from "triangular/components/form/FormSection/FormSection";
import { MaterialForm } from "triangular/components/form/MaterialForm/MaterialForm";
import { useMaterialData } from "triangular/components/form/MaterialForm/useMaterialData";
import { Layout } from "triangular/components/Layout/Layout";
import { routes } from "triangular/Routes/routesConfiguration";
import { FormAdditionalContext } from "triangular/utils/components";

interface MaterialDetailsProps {
  id: string;
  history: History;
}

export const MaterialDetails: React.FC<MaterialDetailsProps> = observer(({ id: materialId, history }) => {
  const { t } = useTranslation();
  const { isLoading, material } = useMaterialData({ materialId });

  return (
    <Layout loading={isLoading} withMolecules={false}>
      {material ? (
        <>
          <FormSection>
            <BackButton />
          </FormSection>
          <FormAdditionalContext.Provider value={{ isReadOnly: true }}>
            <MaterialForm initialValues={material} onGoBack={() => history.push(routes.myMaterialsList.build())} />
          </FormAdditionalContext.Provider>
        </>
      ) : (
        t("editMaterial.fetchFailed")
      )}
    </Layout>
  );
});
